import React from "react";
import { Link } from "react-router-dom";
import { VALUES, STATS, ABOUT_IMG, WORKER_IMG } from "@/lib/content";

export default function APropos() {
  return (
    <div className="bg-[#0a0a0a] text-white pt-32 pb-24" data-testid="about-page">
      <section className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-8">
            <div className="eyebrow mb-4">/ À propos · DCR-BATI</div>
            <h1 className="font-display font-bold uppercase tracking-tighter text-5xl md:text-7xl leading-[0.92]">
              Bâtisseurs<br /><span className="text-[#ffd600]">de structures vraies.</span>
            </h1>
          </div>
          <div className="md:col-span-4 text-neutral-400 text-lg leading-relaxed">
            Une entreprise familiale de gros œuvre, fondée sur la rigueur du béton armé et le respect de la parole donnée.
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 mt-16 grid grid-cols-1 md:grid-cols-12 gap-8">
        <div className="md:col-span-7">
          <img src={ABOUT_IMG} alt="Équipe DCR-BATI" className="w-full h-[520px] object-cover" />
        </div>
        <div className="md:col-span-5 flex flex-col justify-center">
          <div className="eyebrow mb-3">/ Notre histoire</div>
          <h2 className="font-display uppercase font-bold tracking-tight text-3xl md:text-4xl leading-[0.95]">
            Près de <span className="text-[#ffd600]">deux décennies</span> au service du gros œuvre.
          </h2>
          <p className="text-neutral-400 mt-5 leading-relaxed">
            Depuis sa création, DCR-BATI s’est spécialisée dans le coffrage, les planchers béton et le platelage de poutres. Nos compagnons sont formés en interne : chaque chantier est l’occasion de transmettre un savoir‑faire exigeant.
          </p>
          <p className="text-neutral-400 mt-4 leading-relaxed">
            Aujourd’hui, nous intervenons sur des projets résidentiels, tertiaires, industriels et publics. Maître d’ouvrage privé ou public, architecte, BET : nous traitons chaque collaboration avec le même niveau d’exigence.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 mt-24">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {STATS.map((s) => (
            <div key={s.label} className="brut-card text-center" data-testid={`about-stat-${s.label}`}>
              <div className="font-display text-5xl text-[#ffd600] font-semibold leading-none">{s.value}</div>
              <div className="font-mono-tech text-xs uppercase tracking-widest text-neutral-400 mt-4">{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 mt-24 grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
        <div className="md:col-span-6 order-2 md:order-1">
          <div className="eyebrow mb-3">/ Valeurs</div>
          <h2 className="font-display uppercase font-bold tracking-tight text-3xl md:text-5xl leading-[0.95]">
            Nos quatre <span className="text-[#ffd600]">engagements.</span>
          </h2>
          <p className="text-neutral-400 mt-5 leading-relaxed max-w-lg">
            Ces principes guident chaque décision sur nos chantiers, depuis la préparation jusqu’à la réception des ouvrages.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8">
            {VALUES.map((v) => (
              <div key={v.title} className="brut-card !p-5">
                <i className={`${v.icon} text-[#ffd600] text-xl`} />
                <div className="font-display uppercase font-semibold mt-3">{v.title}</div>
                <div className="text-neutral-400 text-sm mt-1">{v.text}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="md:col-span-6 order-1 md:order-2 relative">
          <img src={WORKER_IMG} alt="Ouvrier DCR-BATI" className="w-full h-[520px] object-cover" />
          <div className="hazard-stripes absolute -bottom-5 -right-5 w-32 h-5 hidden md:block" />
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-6 md:px-10 mt-24 text-center">
        <h2 className="font-display uppercase tracking-tight text-3xl md:text-5xl">
          « Un ouvrage en béton armé, ça ne se rattrape pas. <span className="text-[#ffd600]">Ça se fait bien du premier coup.</span> »
        </h2>
        <div className="mt-4 font-mono-tech uppercase text-xs tracking-widest text-neutral-500">— Direction technique DCR-BATI</div>
        <div className="mt-10">
          <Link to="/devis" className="btn-primary" data-testid="about-devis-cta">
            Lancer un chantier avec nous <i className="fa-solid fa-arrow-right" />
          </Link>
        </div>
      </section>
    </div>
  );
}
